import { render, staticRenderFns } from "./EstadoDeCuentaRptComponent.vue?vue&type=template&id=664d1066&"
import script from "./EstadoDeCuentaRptComponent.vue?vue&type=script&lang=js&"
export * from "./EstadoDeCuentaRptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports